(function () {
	var $btn	= document.querySelector('#mbl__toggler');
	var $menu 	= document.querySelector('.topo__main');
	var $topo   = document.querySelector('.topo');

	if (!$btn || !$menu || !$topo) return;

	$btn.addEventListener('click', function(event) {
		event.preventDefault();

		$menu.classList.add('topo__main--shown');
		$btn.classList.add('menu__toggler--active');

		$btn.setAttribute('aria-expanded', true);

		var $bg = document.createElement('div');

		$bg.classList.add('bg__menu');

		$bg.addEventListener('click', function() {
			$bg.classList.add('hide');

			$menu.classList.remove('topo__main--shown');
			$btn.classList.remove('menu__toggler--active');

			$btn.setAttribute('aria-expanded', false);

			$bg.addEventListener('animationend', function() {
				$topo.removeChild($bg);
			});
		});

		$topo.appendChild($bg);
	});
})();
